// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

interface GetSelectorParams {
    caseId: string;
}

export const computeGetSelector = ({ caseId }: GetSelectorParams): QuerySelector => ({
    head: [{ name: 'getCase', idOrName: caseId }],
    name: `get-case-${caseId}`,
    extraData: [
        'owningOrganisation',
        'procedureCount',
        'actionRequired',
        'status',
        'observableStats',
        'taskStats',
        'alerts',
        'isOwner',
        'shareCount',
        'contributors',
        'permissions',
        'computed.handlingDurationInSeconds',
    ],
});

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listCase' }],
    extraData: [
        'alerts',
        'owningOrganisation',
        'observableStats',
        'taskStats',
        'procedureCount',
        'isOwner',
        'shareCount',
        'permissions',
        'actionRequired',
        'contributors',
        'status',
    ],
    name: 'get-all-cases',
    sort: ['-flag', '-_createdAt'],
});
